export const handleEmiratesIdChange = (
e,
setEmiratesId,
setErrorMessage,
translationMap) =>
{
  let value = e.target.value.replace(/\D/g, "");
  if (value.length > 15) {
    value = value.slice(0, 15);
  }
  setEmiratesId(value);
  if (value === "") {
    setErrorMessage("");
  } else if (value.length !== 15) {
    setErrorMessage(translationMap?.emiratesIdShouldBeFifteen || "Emirates ID should be 15 digits");
  } else {
    const formatted = `${value.slice(0, 3)}-${value.slice(3, 7)}-${value.slice(
      7,
      14
    )}-${value.slice(14)}`;
    setEmiratesId(formatted);
    setErrorMessage("");
  }
};